import { XMarkIcon } from "@heroicons/react/24/outline";

import {
  formatSearchSynopsisTerm,
  getSearchSynopsisOperatorPhrase,
  getSearchSynopsisRemoval,
} from "../../../util/search/searchSynopsis";
const getTermPrefix = term => {
  const phrase = getSearchSynopsisOperatorPhrase(term.operator);
  if (term.values.length === 0 || !phrase) return term.label;
  return `${term.label} ${phrase}`;
};

// Value-less operators ("Email is empty") show the operator as the tag.
const getTermValues = term =>
  term.values.length > 0
    ? term.values
    : [
        {
          label: getSearchSynopsisOperatorPhrase(term.operator) || "",
          value: null,
        },
      ];

const SearchSynopsisTag = props => {
  const { label, onRemove, removeLabel } = props;

  return (
    <span className="inline-flex items-center gap-1 rounded border border-gray-300 bg-gray-100 py-0.5 pl-2 pr-1 font-medium shadow-sm">
      {label}
      {onRemove && (
        <button
          aria-label={`Remove ${removeLabel}`}
          className="rounded p-0.5 text-gray-500 hover:bg-gray-200 hover:text-black"
          onClick={onRemove}
          title={`Remove ${removeLabel}`}
          type="button"
        >
          <XMarkIcon className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      )}
    </span>
  );
};

export const SearchSynopsisHeading = props => {
  const { onRemove, terms } = props || {};
  if (!terms?.length) return null;

  return (
    <span className="flex flex-wrap items-center gap-x-3 gap-y-1 normal-case">
      {terms.map(term => (
        <span
          className="inline-flex flex-wrap items-center gap-1 text-sm font-normal"
          key={term.path}
        >
          <span>{getTermPrefix(term)}</span>
          {getTermValues(term).map(value => (
            <SearchSynopsisTag
              key={value.path || value.value || value.label}
              label={value.label}
              onRemove={
                onRemove
                  ? () => onRemove(getSearchSynopsisRemoval(term, value))
                  : undefined
              }
              removeLabel={
                term.values.length > 1
                  ? `${term.label} ${value.label}`
                  : formatSearchSynopsisTerm(term)
              }
            />
          ))}
        </span>
      ))}
    </span>
  );
};
